// 消息类型：1(回复)、2(点赞)、3(关注)、4(分享)、5(打赏)、6(下单)、7(跟单)、8(反馈留言)、9合约交易成功、10合约交易失败、14直播开播提醒、15公告、16现货交易成功、17现货交易失败、18充值成功、19直播预约提醒(弃用)、20主播关闭预约通知、25内容审核通知
// 消息分类：官方公告：15，系统通知：8、25，账户消息：5、6、7、9、10、16、17、18，互动消息：1、2、3、4、14、19(弃用)、20
// 需要detailData： 1-7

export type CategoryKey = 'announcement' | 'system' | 'account' | 'interactions';

const CATEGORY_MAP: Record<CategoryKey, number[]> = {
  announcement: [15],
  system: [8, 25],
  account: [5, 6, 7, 9, 10, 16, 17, 18],
  interactions: [1, 2, 3, 4, 14, 20],
};

// i18n label key 映射
const CATEGORY_LABEL_MAP: Record<CategoryKey, string> = {
  announcement: 'header.official',
  system: 'header.system',
  account: 'header.account',
  interactions: 'header.interactions',
};

/** messageType → 分类 key */
export const getCategoryKey = (messageType: number): CategoryKey | null => {
  for (const [key, types] of Object.entries(CATEGORY_MAP)) {
    if (types.includes(messageType)) return key as CategoryKey;
  }
  return null;
};

/** messageType → 分类标签（需传入 t 函数） */
export const getCategoryTag = (messageType: number, t: (key: string) => string): { label: string } | null => {
  const key = getCategoryKey(messageType);
  if (!key) return null;
  return { label: t(CATEGORY_LABEL_MAP[key]) };
};
